import serviceHTTPHelper from './service-http-helper';

var DiyServicesSDK = function DiyServicesSDK(ServiceSDK, diyServicesBaseUrl) {
  function diyServicesRouteV1(endpoint) {
    return "".concat(ServiceSDK.nwApiRoute(diyServicesBaseUrl, 'consumer-credit', 1, endpoint), "/");
  }

  function diyServicesRouteV2(endpoint) {
    return "".concat(ServiceSDK.nwApiRoute(diyServicesBaseUrl, 'consumer-credit', 2, endpoint), "/");
  }

  var serviceV1 = serviceHTTPHelper(ServiceSDK, diyServicesRouteV1);
  var serviceV2 = serviceHTTPHelper(ServiceSDK, diyServicesRouteV2);

  function getProductRecommendations(params, serverRequest) {
    return serviceV1.get('recommendations', params, serverRequest);
  } // Gets a debt paydown summary
  // params
  //  - debts: array of { apr, balance_amount, debt_type, monthly_payment, name }
  //  - additional_monthly_payment


  function getDebtPayoff(params, serverRequest) {
    return serviceV1.post('debt/payoff', params, serverRequest);
  } // Gets full goal details for debt goal
  // params
  //  - transactions: array,
  //  - accounts: array,
  //  - monthly_contribution: total amount user can pay towards debt per month


  function getDebtGoalDetails(params, serverRequest) {
    return serviceV1.post('debt/goal', params, serverRequest);
  } // Gets full goal details for debt goal allowing backend to handle data massaging
  // params
  //  - transactions: array,
  //  - accounts: array,
  //  - monthly_contribution: total amount user can pay towards debt per month


  function getDebtGoalDetailsRawData(params, serverRequest) {
    return serviceV2.post('debt/goal', params, serverRequest);
  }

  return {
    getProductRecommendations: getProductRecommendations,
    getDebtPayoff: getDebtPayoff,
    getDebtGoalDetails: getDebtGoalDetails,
    getDebtGoalDetailsRawData: getDebtGoalDetailsRawData
  };
};

export default DiyServicesSDK;